import * as React from "react";
import { Hr } from "@grandvisionhq/elements";
import { useProductData } from "../../../../../../../../../../../../context/context/product-context-hooks.js";
const EmptyTree = ({ treeVariants }) => {
  const { facetConfigList } = useProductData();
  const facetConfig = facetConfigList?.find(
    (config) => config.facetKey === treeVariants[0]?.facetKey
  );
  const Right = facetConfig?.slots?.Right;
  if (!Right) return null;
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Right, { treeLevelVariants: treeVariants, facetKey: facetConfig.facetKey }), /* @__PURE__ */ React.createElement(Hr, null));
};
export {
  EmptyTree
};
//# sourceMappingURL=EmptyTree.js.map
